'use client'

/**
 * Error boundary global do App Router. Captura erros do root layout e
 * erros não-tratados de Server Components que escapam dos error.tsx
 * mais específicos. Sem isso, erros do root layout não chegam no Sentry.
 *
 * Documentação: https://nextjs.org/docs/app/building-your-application/routing/error-handling#handling-errors-in-root-layouts
 */
import * as Sentry from '@sentry/nextjs'
import NextError from 'next/error'
import { useEffect } from 'react'

export default function GlobalError({
  error,
}: {
  error: Error & { digest?: string }
}) {
  useEffect(() => {
    Sentry.captureException(error)
  }, [error])

  return (
    <html lang="pt-BR">
      <body>
        <NextError statusCode={0} />
      </body>
    </html>
  )
}
